/* eslint-disable react/jsx-max-depth */ function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { useTour } from '@reactour/tour';
import classNames from 'classnames';
import _ from 'lodash/fp';
import React, { useContext, useEffect, useMemo, useRef, useState } from 'react';
import { Col, Dropdown, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import Button from '../../components/button/Button';
import MembershipButton from '../../components/button/MembershipButton';
import MeatballDropdown from '../../components/dropdown/MeatballDropdown';
import { DELETE_PROJECT_MODAL } from '../../components/modal/DeleteProjectModal';
import { DEMO_PROJECT_ACTION_MODAL } from '../../components/modal/DemoProjectActionsModal';
import { INITIATE_TOUR_MODAL } from '../../components/modal/InitiateTourModal';
import { MERGE_PROJECT_MODAL } from '../../components/modal/MergeProjectModal';
import { ADD_NOTE_MODAL } from '../../components/modal/addNoteModal/AddNoteModal';
import { INVITE_PROJECT_USERS_MODAL } from '../../components/modal/inviteProjectUsersModal/InviteProjectUsersModal';
import { POINTERRA_ID_MODAL } from '../../components/modal/pointerraIDModal/PointerraIDModal';
import { UPDATE_PRODUCT_MODAL } from '../../components/modal/updateProductModal/UpdateProductModal';
import { UPLOAD_ASSET_MODAL } from '../../components/modal/uploadAssetModal';
import Page from '../../components/page/Page';
import { AMPLITUDE_EVENTS } from '../../constants/analytics';
import { DOWNLOAD_ALL_JOB_STATUS } from '../../constants/asset';
import { FETCH_STATUS } from '../../constants/project';
import useBreakpoint from '../../hooks/useBreakpoint';
import useEventListener from '../../hooks/useEventListener';
import { usePoll } from '../../hooks/usePoll';
import useProjectPermissions from '../../hooks/useProjectPermissions';
import { useRedirect } from '../../hooks/useRedirect';
import useUpdateBookmarkRequest from '../../hooks/useUpdateBookmarkRequest';
import { alertError, alertWarning, listProjectActivities, toggleStaffActivities } from '../../redux/actions';
import { hideModal, showModal } from '../../redux/actions/modal';
import { generateDownloadAllUrl, getDownloadAllUrl, getLatestProject, getProjectById, resumeDownloadAll, setCurrentProject } from '../../redux/actions/project';
import { getTourStatus } from '../../redux/actions/tour';
import { DOWNLOAD_ALL_STATUS } from '../../redux/constants';
import { profileSelectors } from '../../redux/selectors/profile';
import routes from '../../routes/constants';
import text from '../../text';
import { amplitudeTrack } from '../../utilities';
import { downloadFile } from '../../utilities/files';
import { getProjectLatestJob, isDemoProject } from '../../utilities/project';
import { LayoutContext } from '../LayoutContext';
import { TOURS } from '../dashboard/components/onboarding/tour';
import ActivityFilterControls from './ActivityFilterControls';
import FileManagerFallbackOverlay from './FileManagerFallbackOverlay';
import JobTimeline from './JobTimeline';
import { useGetProjectQuery, useReinitiateJobMutation } from '../../redux/rtk';
import useUser from '../../mp/hooks/useUser';
import Onboarding from '../dashboard/components/onboarding';
var FILE_MANAGER = AMPLITUDE_EVENTS.FILE_MANAGER;
// TODO: Apply Lint suggestions on dependencies
var FileManager = function() {
    var history = useHistory();
    var redirect = useRedirect();
    var projectId = useParams().projectId;
    var dispatch = useDispatch();
    var _useSelector = useSelector(function(state) {
        var _state_activity_projects_projectId;
        return {
            currentProject: state.project.currentProject,
            getCurrentProjectStatus: state.project.getCurrentProjectStatus,
            currentUser: state.profileReducer.userProfile,
            isStaffActivityListVisible: state.activity.isStaffActivityListVisible,
            downloadAll: state.project.downloadAll,
            tourSelected: state.tourReducer.tourSelected,
            activities: ((_state_activity_projects_projectId = state.activity.projects[projectId]) === null || _state_activity_projects_projectId === void 0 ? void 0 : _state_activity_projects_projectId.activities) || []
        };
    }), currentProject = _useSelector.currentProject, getCurrentProjectStatus = _useSelector.getCurrentProjectStatus, downloadAll = _useSelector.downloadAll, tourSelected = _useSelector.tourSelected, activities = _useSelector.activities;
    var isAdmin = useSelector(profileSelectors.getIsAdmin);
    var setStartNewProjectHighlight = useContext(LayoutContext).setStartNewProjectHighlight;
    var downloadAllState = downloadAll[projectId];
    var _useState = _sliced_to_array(useState(0), 2), zipProgress = _useState[0], setZipProgress = _useState[1];
    var _useState1 = _sliced_to_array(useState(null), 2), isNavBarSticky = _useState1[0], setNavBarIsSticky = _useState1[1];
    var fileManagerContainerRef = useRef(null);
    var getProjectState = useGetProjectQuery({
        projectId: projectId
    });
    var currentUser = useUser();
    var _useReinitiateJobMutation = _sliced_to_array(useReinitiateJobMutation(), 2), reinitiateJob = _useReinitiateJobMutation[0], reinitiateJobState = _useReinitiateJobMutation[1];
    /* ---------- PROJECT ---------- */ /**
   * Redirect to request access page if unauthorized to view this project.
   */ useEffect(function() {
        var err = getProjectState.error;
        if (err && err.status === 403) {
            dispatch(alertWarning('Requesting access...'));
            var page = history.location.pathname;
            redirect.push(routes.requestAccess.project.url(projectId), {
                queryParams: {
                    page: page
                }
            });
        }
    }, [
        dispatch,
        getProjectState.error,
        history.location.pathname,
        projectId,
        redirect
    ]);
    var hasCurrentProject = useMemo(function() {
        return !!(currentProject === null || currentProject === void 0 ? void 0 : currentProject.id);
    }, [
        currentProject
    ]);
    // fetch the project by projectId if present, latest otherwise
    useEffect(function() {
        if (projectId) {
            dispatch(getProjectById(projectId, {
                includeJobs: true,
                includePointCloud: true,
                includeQuote: true
            }));
        } else {
            dispatch(getLatestProject({
                isAdmin: false,
                includeDemo: false,
                includeJobs: true,
                includePointCloud: true
            }));
        }
        // if current project is a demo, reset the current project state so returning to the file manager
        return function() {
            if ((currentProject === null || currentProject === void 0 ? void 0 : currentProject.id) && isDemoProject(currentProject)) dispatch(setCurrentProject(null));
        };
    }, [
        projectId
    ]);
    // once fetched if projectId not present, redirect to that project's URL
    useEffect(function() {
        if (!projectId && getCurrentProjectStatus === FETCH_STATUS.DONE && (currentProject === null || currentProject === void 0 ? void 0 : currentProject.id)) {
            redirect.push("".concat(routes.fileManager.root, "/").concat(currentProject.id));
        }
    }, [
        getCurrentProjectStatus,
        currentProject
    ]);
    var isFileManagerFallback = useMemo(function() {
        return getCurrentProjectStatus === FETCH_STATUS.DONE && !hasCurrentProject;
    }, [
        getCurrentProjectStatus,
        hasCurrentProject
    ]);
    useEffect(function() {
        setStartNewProjectHighlight(isFileManagerFallback);
        return function() {
            setStartNewProjectHighlight(false);
        };
    }, [
        isFileManagerFallback
    ]);
    /* -------------------- */ var latestJob = useMemo(function() {
        if (!currentProject) return null;
        var job = getProjectLatestJob(currentProject);
        return _object_spread(_object_spread_props(_object_spread({}, job), {
            project: currentProject
        }), _.pick([
            'user_project',
            'jobs',
            'point_clouds',
            'updated_at'
        ], currentProject));
    }, [
        currentProject
    ]);
    var hasLatestJob = useMemo(function() {
        return !_.isEmpty(latestJob);
    }, [
        latestJob
    ]);
    var projectPermissions = useProjectPermissions(currentProject);
    var zipProgressPct = useMemo(function() {
        return Math.floor(100 * zipProgress);
    }, [
        zipProgress
    ]);
    var handle2DMapClick = function(event) {
        event.preventDefault();
        if (!hasLatestJob) {
            console.warn('tried 2D map click without latest job');
            return;
        }
        var _2dMapRoute = latestJob.mp_enabled ? routes.mp.job(latestJob.id) : routes.order.job(latestJob.id);
        redirect.push(isAdmin ? "".concat(_2dMapRoute, "?admin=true") : _2dMapRoute);
    };
    var handle3DViewerClick = function(event) {
        event.preventDefault();
        if (!projectId) {
            console.warn('tried 3D viewer click without projectId');
            return;
        }
        redirect.push(isAdmin ? "".concat(routes.view3DExternal.root, "/").concat(projectId, "?admin=true") : "".concat(routes.view3DExternal.root, "/").concat(projectId));
    };
    var _usePoll = usePoll({
        callback: /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function(stopPolling) {
                var data, status, url, newZipProgress;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!projectId || !(downloadAllState === null || downloadAllState === void 0 ? void 0 : downloadAllState.queueJobId)) {
                                return [
                                    2
                                ];
                            }
                            return [
                                4,
                                dispatch(getDownloadAllUrl(projectId, downloadAllState.queueJobId))
                            ];
                        case 1:
                            data = _state.sent();
                            if (!data) {
                                stopPolling();
                                return [
                                    2
                                ];
                            }
                            status = data.status, url = data.url, newZipProgress = data.zipProgress;
                            switch(status){
                                case DOWNLOAD_ALL_JOB_STATUS.AVAILABLE:
                                    downloadFile(url);
                                    stopPolling();
                                    break;
                                case DOWNLOAD_ALL_JOB_STATUS.PROCESSING:
                                    setZipProgress(newZipProgress);
                                    break;
                                case DOWNLOAD_ALL_JOB_STATUS.FAILED:
                                    console.error('failed to generate download URL');
                                    stopPolling();
                                    break;
                                default:
                                    console.error("unknown status: ".concat(status));
                                    stopPolling();
                                    break;
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function(stopPolling) {
                return _ref.apply(this, arguments);
            };
        }(),
        dependencies: [
            projectId,
            downloadAllState === null || downloadAllState === void 0 ? void 0 : downloadAllState.queueJobId
        ],
        startEnabled: false,
        delay: 5000
    }), pollDownload = _usePoll.poll;
    var handleDownloadAll = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function() {
            var downloadIfAvailable, activitiesWithAssets, allActivitiesSuperseded, data, status, url;
            var _arguments = arguments;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        downloadIfAvailable = (_arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {}).downloadIfAvailable;
                        activitiesWithAssets = activities.filter(function(activity) {
                            var _activity_created_assets;
                            return ((_activity_created_assets = activity.created_assets) === null || _activity_created_assets === void 0 ? void 0 : _activity_created_assets.length) > 0;
                        });
                        allActivitiesSuperseded = activitiesWithAssets.length > 0 && activitiesWithAssets.every(function(activity) {
                            var _activity_superseded_assets, _activity_created_assets;
                            return ((_activity_superseded_assets = activity.superseded_assets) === null || _activity_superseded_assets === void 0 ? void 0 : _activity_superseded_assets.length) === ((_activity_created_assets = activity.created_assets) === null || _activity_created_assets === void 0 ? void 0 : _activity_created_assets.length);
                        });
                        if (allActivitiesSuperseded) {
                            dispatch(alertWarning(text('downloadAllUnavailable')));
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            dispatch(generateDownloadAllUrl(projectId))
                        ];
                    case 1:
                        data = _state.sent();
                        if (!data) {
                            return [
                                2
                            ];
                        }
                        status = data.status, url = data.url;
                        switch(status){
                            case DOWNLOAD_ALL_JOB_STATUS.AVAILABLE:
                                if (downloadIfAvailable) {
                                    downloadFile(url);
                                }
                                break;
                            case DOWNLOAD_ALL_JOB_STATUS.PROCESSING:
                                pollDownload(true);
                                break;
                            case DOWNLOAD_ALL_JOB_STATUS.UNAVAILABLE:
                            case DOWNLOAD_ALL_JOB_STATUS.FAILED:
                                break;
                            default:
                                console.error('unknown status', status);
                                break;
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function handleDownloadAll() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleDownloadAllClick = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function() {
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        amplitudeTrack(FILE_MANAGER.EVENT, {
                            action: FILE_MANAGER.DOWNLOAD_ALL_BUTTON
                        });
                        return [
                            4,
                            handleDownloadAll({
                                downloadIfAvailable: true
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleDownloadAllClick() {
            return _ref.apply(this, arguments);
        };
    }();
    var downloadAllResumed = useRef(false);
    useEffect(function() {
        if (projectId) {
            dispatch(resumeDownloadAll(projectId));
        }
    }, [
        projectId
    ]);
    useEffect(function() {
        if (downloadAllResumed.current) {
            return;
        }
        if (projectId && (downloadAllState === null || downloadAllState === void 0 ? void 0 : downloadAllState.isLoading) && (downloadAllState === null || downloadAllState === void 0 ? void 0 : downloadAllState.queueJobId)) {
            pollDownload(true);
            downloadAllResumed.current = true;
        }
    }, [
        projectId,
        downloadAllState === null || downloadAllState === void 0 ? void 0 : downloadAllState.queueJobId
    ]);
    // useEffect(() => {
    //   if (!isEmpty(currentUser)) {
    //     dispatch(isAdmin ? getAdminJobsList() : getJobsList());
    //   }
    // }, [currentUser]);
    /* ---------- TOURS ---------- */ var _useTour = useTour(), steps = _useTour.steps, setSteps = _useTour.setSteps, setCurrentStep = _useTour.setCurrentStep;
    useEffect(function() {
        if (steps.length && tourSelected) {
            dispatch(showModal(INITIATE_TOUR_MODAL));
        }
    }, [
        steps,
        tourSelected
    ]);
    useEffect(function() {
        // need to only start the tour if a valid project
        if (getCurrentProjectStatus === FETCH_STATUS.DONE && hasCurrentProject) {
            dispatch(getTourStatus(TOURS.TOUR_FILE_MANAGER, setSteps, setCurrentStep));
        }
        return function() {
            setSteps([]); // clean up tour steps on unmount
        };
    }, []);
    useEventListener('scroll', function(e) {
        var _fileManagerContainerRef_current;
        var scrollTop = e.target.scrollTop;
        if (!((_fileManagerContainerRef_current = fileManagerContainerRef.current) === null || _fileManagerContainerRef_current === void 0 ? void 0 : _fileManagerContainerRef_current.contains(e.target))) {
            return;
        }
        // only reset to false when scrolled back to top
        // to avoid changing header in middle of interaction when the scrollTop < 250, might confuse the user the header is gone
        if (scrollTop === 0) {
            setNavBarIsSticky(false);
        }
        if (scrollTop > 0) {
            setNavBarIsSticky(true);
        }
    }, {}, true);
    useEffect(function() {
        if (reinitiateJobState.error) {
            var _reinitiateJobState_error_data;
            dispatch(alertError((_reinitiateJobState_error_data = reinitiateJobState.error.data) === null || _reinitiateJobState_error_data === void 0 ? void 0 : _reinitiateJobState_error_data.message));
        }
    }, [
        reinitiateJobState.error,
        dispatch
    ]);
    var isScreenTabletAndUp = useBreakpoint([
        'md',
        'lg',
        'xl'
    ]);
    var isUpdatingBookmarkRequest = useUpdateBookmarkRequest().isUpdatingBookmarkRequest;
    return /*#__PURE__*/ React.createElement(Page, {
        className: "FileManager",
        title: text('fileManager'),
        noPadding: true,
        showTitlebar: false,
        ref: fileManagerContainerRef
    }, isUpdatingBookmarkRequest ? /*#__PURE__*/ React.createElement("div", {
        className: "progress-bar top-appbar-loader"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "progress-bar-value"
    })) : null, /*#__PURE__*/ React.createElement("div", {
        className: classNames({
            'is-sticky elevation': isScreenTabletAndUp && isNavBarSticky,
            'sticky-top': isScreenTabletAndUp
        })
    }, /*#__PURE__*/ React.createElement("div", {
        className: "topnav d-flex flex-column",
        style: {
            width: '100%'
        }
    }, /*#__PURE__*/ React.createElement(ActivityFilterControls, {
        id: "ActivityFilterControls-secondary",
        projectId: projectId,
        currentProject: currentProject
    }), /*#__PURE__*/ React.createElement("div", {
        className: "Controls"
    }, /*#__PURE__*/ React.createElement(Col, {
        className: "left"
    }, /*#__PURE__*/ React.createElement(Button, {
        id: "inviteProjectUsersButton",
        variant: "outline-primary",
        icon: "user",
        tooltipProps: {
            text: text('inviteViewProjectUsers')
        },
        onClick: function() {
            amplitudeTrack(FILE_MANAGER.EVENT, {
                action: FILE_MANAGER.SHARE_BUTTON
            });
            return dispatch(!isDemoProject(currentProject) ? showModal(INVITE_PROJECT_USERS_MODAL, {
                onHide: function() {
                    dispatch(hideModal(INVITE_PROJECT_USERS_MODAL));
                    dispatch(listProjectActivities(projectId));
                },
                project: currentProject,
                job: getProjectLatestJob(currentProject)
            }) : showModal(DEMO_PROJECT_ACTION_MODAL));
        }
    }, text('share')), /*#__PURE__*/ React.createElement(Button, {
        id: "addNoteButton",
        icon: "speech",
        variant: "outline-primary",
        tooltipProps: {
            text: text('addNote')
        },
        onClick: function() {
            amplitudeTrack(FILE_MANAGER.EVENT, {
                action: FILE_MANAGER.NOTE_BUTTON
            });
            return dispatch(!isDemoProject(currentProject) ? showModal(ADD_NOTE_MODAL, {
                onHide: function() {
                    return dispatch(hideModal(ADD_NOTE_MODAL));
                },
                job: latestJob
            }) : showModal(DEMO_PROJECT_ACTION_MODAL));
        }
    }, text('note')), /*#__PURE__*/ React.createElement(Button, {
        id: "uploadFileButton",
        variant: "outline-primary",
        tooltipProps: {
            text: text('uploadFiles')
        },
        icon: "clip",
        onClick: function() {
            amplitudeTrack(FILE_MANAGER.EVENT, {
                action: FILE_MANAGER.UPLOAD_BUTTON
            });
            return dispatch(!isDemoProject(currentProject) ? showModal(UPLOAD_ASSET_MODAL, {
                projectId: projectId
            }) : showModal(DEMO_PROJECT_ACTION_MODAL));
        }
    }, text('upload')), /*#__PURE__*/ React.createElement(Button, {
        className: classNames('download-all-button', (downloadAllState === null || downloadAllState === void 0 ? void 0 : downloadAllState.isLoading) && 'loading'),
        variant: "outline-primary",
        icon: (downloadAllState === null || downloadAllState === void 0 ? void 0 : downloadAllState.status) === DOWNLOAD_ALL_STATUS.ZIPPING ? 'zip' : 'download',
        onClick: function() {
            if (!(downloadAllState === null || downloadAllState === void 0 ? void 0 : downloadAllState.isLoading)) {
                handleDownloadAllClick(projectId);
            }
        }
    }, !downloadAllState || downloadAllState.status === DOWNLOAD_ALL_STATUS.IDLE ? text('downloadAll') : (downloadAllState === null || downloadAllState === void 0 ? void 0 : downloadAllState.status) === DOWNLOAD_ALL_STATUS.ZIPPING ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("span", null, text('zipping'), /*#__PURE__*/ React.createElement("span", {
        className: "ellipsis"
    }, "...")), /*#__PURE__*/ React.createElement("span", {
        className: "pct"
    }, "".concat(zipProgressPct, "%"))) : /*#__PURE__*/ React.createElement("span", null, text('downloading'), /*#__PURE__*/ React.createElement("span", {
        className: "ellipsis"
    }, "..."))), /*#__PURE__*/ React.createElement(MeatballDropdown, {
        tooltipProps: {
            text: text('more'),
            placement: 'top'
        },
        btnClassName: "btn btn-outline-primary"
    }, /*#__PURE__*/ React.createElement(Dropdown.Item, {
        disabled: !projectPermissions.is2dMapEnabled,
        onClick: handle2DMapClick
    }, text('map2D')), /*#__PURE__*/ React.createElement(Dropdown.Item, {
        onClick: handle3DViewerClick,
        disabled: !projectPermissions.is3dViewerEnabled
    }, text('viewer3D')), /*#__PURE__*/ React.createElement(Dropdown.Item, {
        id: "downloadItem",
        onClick: handleDownloadAllClick
    }, text('downloadAll')), currentUser.isStaff ? /*#__PURE__*/ React.createElement(Dropdown.Item, {
        id: "initate",
        onClick: function() {
            if (!latestJob) return;
            reinitiateJob({
                jobId: latestJob.id
            });
        }
    }, "Manually initiate latest job (staff-only)") : null, projectPermissions.isAdministrationEnabled ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Dropdown.Divider, null), /*#__PURE__*/ React.createElement(Dropdown.Item, {
        disabled: !projectId,
        onClick: function() {
            return dispatch(showModal(POINTERRA_ID_MODAL, {
                onHide: function() {
                    dispatch(hideModal(POINTERRA_ID_MODAL));
                    dispatch(listProjectActivities(projectId));
                },
                job: latestJob
            }));
        }
    }, text('pointerraHash')), /*#__PURE__*/ React.createElement(Dropdown.Item, {
        id: "updateProductButton",
        variant: "outline-primary",
        icon: "circle",
        tooltipProps: {
            text: text('updateProductStatus')
        },
        disabled: !projectId,
        onClick: function() {
            return dispatch(showModal(UPDATE_PRODUCT_MODAL, {
                onHide: function() {
                    return dispatch(hideModal(UPDATE_PRODUCT_MODAL));
                },
                job: latestJob
            }));
        }
    }, text('statusUpdate')), /*#__PURE__*/ React.createElement(Dropdown.Item, {
        onClick: function() {
            return dispatch(toggleStaffActivities());
        }
    }, text('showLarkiLogs')), /*#__PURE__*/ React.createElement(Dropdown.Divider, null)) : null, !isDemoProject(currentProject) && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Dropdown.Item, {
        onClick: function() {
            return dispatch(showModal(MERGE_PROJECT_MODAL, {
                currentJob: currentProject,
                onSuccess: function(targetProject) {
                    return redirect.push(routes.fileManager.viewProject(targetProject === null || targetProject === void 0 ? void 0 : targetProject.id));
                }
            }));
        }
    }, text('mergeProjects')), /*#__PURE__*/ React.createElement(Dropdown.Divider, null), /*#__PURE__*/ React.createElement(Dropdown.Item, {
        className: "red",
        disabled: !projectPermissions.isDeleteEnabled,
        onClick: function() {
            return dispatch(showModal(DELETE_PROJECT_MODAL, {
                projectId: projectId,
                name: currentProject.name,
                onSuccess: function() {
                    dispatch(setCurrentProject(null));
                    redirect.push(routes.dashboard);
                }
            }));
        }
    }, text('deleteProject'))))), /*#__PURE__*/ React.createElement(Col, {
        className: "right"
    }, /*#__PURE__*/ React.createElement(Row, null, /*#__PURE__*/ React.createElement(MembershipButton, {
        variant: "outline-primary"
    }), /*#__PURE__*/ React.createElement(Button, {
        className: "add-order-button",
        variant: "primary",
        onClick: function(event) {
            event.preventDefault();
            history.push(_object_spread({
                pathname: routes.mp.root
            }, !isDemoProject(currentProject) ? {
                search: "?projectId=".concat(currentProject === null || currentProject === void 0 ? void 0 : currentProject.projectId)
            } : {}));
        },
        icon: "plus"
    }, text('addOrderToProject'))))), /*#__PURE__*/ React.createElement(ActivityFilterControls, {
        id: "ActivityFilterControls-tour",
        projectId: projectId
    }))), /*#__PURE__*/ React.createElement(FileManagerFallbackOverlay, {
        show: isFileManagerFallback
    }), hasCurrentProject ? /*#__PURE__*/ React.createElement(JobTimeline, null) : null, /*#__PURE__*/ React.createElement(Onboarding, null));
};
export default FileManager;
